/**
 * Shared constants for the Pro mobile push-notification flow.
 */

/**
 * sessionStorage key handshaking the post-login push permission prompt.
 *
 * `handleLoginSuccess` sets this on a fresh native Pro sign-in; the
 * `useProPushNotifications` hook consumes it once on mount to decide whether to
 * show the OS permission dialog. Kept here so the producer (a plain util) and
 * the consumer (a React hook) share one literal without depending on each other.
 *
 * sessionStorage is cleared when the WebView process dies, so the flag cannot
 * survive a cold start — push is never auto-prompted on relaunch.
 */
export const PUSH_AFTER_LOGIN_FLAG = 'pro:requestPushOnMount';
